// Module
var code = `<section class="page-body default-content">
  <h2>Card Grid</h2>
  <p>
    The <code>.card-grid</code> container is used to display a set of cards in a responsive layout.
    Use the <code>.cards-container</code> and <code>.card-list</code> classes to ensure cards are
    aligned consistently across all screen sizes.
  </p>

  <h3>Responsive Grid Layout</h3>
  <p>
    Use <code>.card-list</code> with <code>li.card</code> children. Each card includes a clickable
    block, optional image, title, metadata, and CTA text.
  </p>

  <div class="docs-example">
    <ul class="cards-container card-list" aria-label="cards">

      <li class="card">
        <a class="page-card" href="#">
          <div class="card__image-wrapper">
            <img
              class="card__image"
              src="https://placehold.co/600x500"
              alt="Placeholder image"
            />
          </div>
          <div class="card__content">
            <h2 class="card__title">Card Title A</h2>
            <p class="card__meta">Brief description for card A.</p>
            <p class="card__meta card__meta__cta">Read More</p>
          </div>
        </a>
      </li>

      <li class="card">
        <a class="page-card" href="#">
          <div class="card__image-wrapper">
            <img
              class="card__image"
              src="https://placehold.co/600x200"
              alt="Placeholder image"
            />
          </div>
          <div class="card__content">
            <h2 class="card__title">Card Title B</h2>
            <p class="card__meta">Brief description for card B.</p>
            <p class="card__meta card__meta__cta">Read More</p>
          </div>
        </a>
      </li>

      <li class="card">
        <a class="page-card" href="#">
          <div class="card__image-wrapper">
            <img
              class="card__image"
              src="https://placehold.co/600x200"
              alt="Placeholder image"
            />
          </div>
          <div class="card__content">
            <h2 class="card__title">Card Title C</h2>
            <p class="card__meta">Brief description for card C.</p>
            <p class="card__meta card__meta__cta">Read More</p>
          </div>
        </a>
      </li>

    </ul>
  </div>

  <pre><code class="language-html hljs" data-highlighted="yes">
&lt;ul class="cards-container card-list" aria-label="cards"&gt;
  &lt;li class="card"&gt;
    &lt;a class="page-card" href="#"&gt;
      &lt;div class="card__image-wrapper"&gt;
        &lt;img class="card__image" src="..." alt="..." /&gt;
      &lt;/div&gt;
      &lt;div class="card__content"&gt;
        &lt;h2 class="card__title"&gt;Card Title&lt;/h2&gt;
        &lt;p class="card__meta"&gt;Brief description.&lt;/p&gt;
        &lt;p class="card__meta card__meta__cta"&gt;Read More&lt;/p&gt;
      &lt;/div&gt;
    &lt;/a&gt;
  &lt;/li&gt;
&lt;/ul&gt;
  </code></pre>
</section>
`;
// Exports
module.exports = code;